import Vue from 'vue'
import Router from 'vue-router'
import UserArea from '@/vue_files/components/User/UserArea'
import Signup from '@/vue_files/components/User/Signup'
import Signin from '@/vue_files/components/User/Signin'
import Downloads from '@/vue_files/components/User/Downloads'
import Buy from '@/vue_files/components/User/Buy'
import ForgotPassword from '@/vue_files/components/User/ForgotPassword'
import WelcomePage from '@/vue_files/components/User/Welcome.vue'
import AuthGuard from './auth-guard'
import Arpeggiator from '@/vue_files/components/User/Arpeggiator'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Annaliis',
      component: () => import('@/vue_files/views/annaliis/Index.vue'),
    },
    {
      path: '/mesarp',
      name: 'Arpeggiator',
      component: Arpeggiator,
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: WelcomePage
    },
    {
      path: '/downloads',
      name: 'Downloads',
      component: Downloads,
      beforeEnter: AuthGuard
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy,
    },
    {
      path: '/userarea',
      name: 'User Area',
      component: UserArea,
      beforeEnter: AuthGuard
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: Signup
    },
    {
      path: '/signin',
      name: 'Sign In',
      component: Signin
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
    },
    {
      path: '/about',
      name: 'About Us',
      component: () => import('@/vue_files/views/about/Index.vue'),
    },
    {
      path: '/sound-design',
      name: 'Sound Design',
      component: () => import('@/vue_files/views/sounddesign/Index.vue'),
    },
    {
      path: '/tutorials',
      name: 'Tutorials',
      component: () => import('@/vue_files/views/tutorials/Index.vue'),
    },
    {
      path: '/podcasts',
      name: 'Podcasts',
      component: () => import('@/vue_files/views/podcasts/Index.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: () => import('@/vue_files/views/privacypolicy/Index.vue'),
    },
  ],
})

router.afterEach((to, from) => {
  // For Google Tag Manager
  if (window.dataLayer) {
    if (to.fullPath === '/welcome') {
      // console.log('Pushing pageview event to dataLayer using to.fullPath:', to.fullPath)
      window.dataLayer.push({
        event: 'welcome_page_hit',
        page: {
          url: to.fullPath,
          title: document.title
        }
      })
    }
  }
})

export default router
